// extracted by mini-css-extract-plugin
export default {"spinner":"kNXSr","loader":"PkJBF"};